import api from '../api';
import { PaginatedActivities, ActivityFilter } from '../../interfaces/activity';

// Interface para as estatísticas das atividades
interface ActivityStats {
  total: number;
  overdue: number;
  completed: number;
  due15Days: number;
  due7Days: number;
}

// Serviço para interagir com a API de atividades
const activityService = {
  // Buscar atividades filtradas
  getFilteredActivities: async (filters: ActivityFilter): Promise<PaginatedActivities> => {
    try {
      // Construir query params a partir dos filtros
      const params = new URLSearchParams();
      
      if (filters.search) params.append('search', filters.search);
      if (filters.status) params.append('status', filters.status);
      if (filters.dueDateFilter) params.append('dueDateFilter', filters.dueDateFilter);
      if (filters.projectId) params.append('projectId', filters.projectId);
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.sortDirection) params.append('sortDirection', filters.sortDirection);
      
      params.append('page', filters.page.toString());
      params.append('pageSize', filters.pageSize.toString());
      
      // A URL base já contém '/api', então precisamos remover o '/api' do início da rota
      const baseUrl = '/admin/activities';
      const response = await api.get(`${baseUrl}?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao buscar atividades:', error);
      throw error;
    }
  },
  
  // Buscar atividades globais (todas do sistema)
  getGlobalActivities: async (filters: ActivityFilter): Promise<PaginatedActivities> => {
    try {
      // Construir query params a partir dos filtros
      const params = new URLSearchParams();
      
      if (filters.search) params.append('search', filters.search);
      if (filters.status) params.append('status', filters.status);
      if (filters.dueDateFilter) params.append('dueDateFilter', filters.dueDateFilter);
      if (filters.projectId) params.append('projectId', filters.projectId);
      if (filters.sortBy) params.append('sortBy', filters.sortBy);
      if (filters.sortDirection) params.append('sortDirection', filters.sortDirection);
      
      params.append('page', filters.page.toString());
      params.append('pageSize', filters.pageSize.toString());
      
      // Endpoint para buscar todas as atividades do sistema
      const baseUrl = '/admin/activities/global';
      const response = await api.get(`${baseUrl}?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao buscar atividades globais:', error);
      throw error;
    }
  },
  
  // Buscar estatísticas das atividades
  getActivityStats: async (filters: Omit<ActivityFilter, 'page' | 'pageSize'>): Promise<ActivityStats> => {
    try {
      // Construir query params a partir dos filtros
      const params = new URLSearchParams();
      
      if (filters.search) params.append('search', filters.search);
      if (filters.status) params.append('status', filters.status);
      if (filters.dueDateFilter) params.append('dueDateFilter', filters.dueDateFilter);
      if (filters.projectId) params.append('projectId', filters.projectId);
      
      // Endpoint para buscar estatísticas das atividades
      const baseUrl = '/admin/activities/global/stats';
      const response = await api.get(`${baseUrl}?${params.toString()}`);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao buscar estatísticas das atividades:', error);
      throw error;
    }
  }
};

export default activityService;